import type {
  BaseBlokComponents,
  BaseSBType,
  MappedBlok,
} from "./type-generators";

interface StoryblokGlobalData {
  blokMap: Partial<BaseBlokComponents>;
}

export const storyblokGlobalData: StoryblokGlobalData = {
  blokMap: {},
};

export const getBlokComponent = (
  key: keyof typeof storyblokGlobalData.blokMap
) => {
  return storyblokGlobalData.blokMap[key];
};

/**
 * Define bloks for StoryblokStory & StoryblokComponent to use.
 * Import this file at the root layout both on client and server
 * @example
 * ```ts
 * import { PageBlok } from "@/components/bloks"
 * type StoryblokTypes = PageStoryblok;
 *
 * defineBloks<StoryblokTypes>({
 *    page: PageBlok,
 * })
 * ```
 *
 * @example - layout.tsx, _Providers.tsx
 * ```ts
 * import "@/lib/bloks"
 *
 * export default function Layout({ children }) {}
 * ```
 */
export function defineStoryblok<
  const T extends BaseSBType,
  ExtraFields extends {} = {},
>({
  bloks,
}: {
  bloks: {
    [key in T["component"]]: MappedBlok<T, ExtraFields, key>;
  };
}) {
  storyblokGlobalData.blokMap = bloks as any;
  return {
    bloks,
  };
}
